import { OmniAction, OmniAuctionState, actions } from "./OmniAuctionState";

export const omniReducer = (state: OmniAuctionState, action: OmniAction) => {
    switch (action.type) {
        case actions.SET_STATEFUL_PRICE:
            return { ...state, statefulPrice: action.payload };
        case actions.SET_AUCTION:
            return { ...state, auction: action.payload };
        case actions.SET_VARIANT:
            return { ...state, variant: action.payload };
        case actions.SET_BID_AMOUNT:
            return { ...state, bidAmount: action.payload };
        case actions.SET_PLACING_BID:
            return { ...state, placingBid: action.payload };
        case actions.SET_CONFIRMING_BID:
            return { ...state, confirmingBid: action.payload };
        case actions.SET_PURCHASE_QUANTITY:
            return { ...state, purchaseQuantity: action.payload };
        default:
            return state;
    }
};

